<template>
	<div>
		<div style="background-color: #fff;"><Myheaderesa></Myheaderesa></div>
		<div class="headerscourdetail">
			<img style="width: 100%;" src="@/images/images/ykc/u12.png" alt="" />
			<div class="headerfonts">
				<p>{{ resourobj.LR_Title }}</p>
				<p>{{ resourobj.pro_name }}</p>
			</div>
		</div>

		<div class="resourcedetils">
			<div class="wrap">
				<div class="resourceleft flex">
					<div>
						<div class="flex resourceleftspan">
							<p>{{ resourobj.pro_name }}</p>
							<p>{{ resourobj.PR_ProfessionalName }}</p>
						</div>
						<p class="resourcetimer">
							<span>{{ resourobj.LR_UploadTime }} {{ resourobj.ui_UserName }} 上传</span>
							|
							<span>{{ size }}</span>
						</p>

						<el-popover placement="right-start" width="220" v-model="visible">
							<div style="height: 200px;border-radius: 10px;"><img style="width: 200px;height: 200px;" :src="qrimg" alt="暂无二维码显示" /></div>
							<img slot="reference" id="imgsscour" style="cursor: pointer;width: 50px;height: 50px;" src="@/images/wxewm.png" @click="prowimg()" alt="" />
						</el-popover>
					</div>

					<div class="resourceright">
						<img v-if="resourobj.LR_SurfacePlotUrl" style="width: 246px;height: 148px;" :src="resourobj.LR_SurfacePlotUrl" alt="这是资源封面" />
						<img v-else style="width: 246px;height: 148px;" src="@/assets/resource.png" alt="这是资源封面" />
					</div>
				</div>
			</div>
		</div>

		<div
			:class="isscreen ? 'screenbox' : 'resourcbottom'"
			class="wrap"
			:style="{ height: changecourse(resourobj.LR_FileSuffix) == '视频' ? '700px' : '' }"
			style="margin-bottom: 70px; "
		>
			<div class="resourcbottomtitle">
				{{ resourobj.LR_FileName }}
				<button v-if="changecourse(resourobj.LR_FileSuffix) !== '视频'" class="resourbtns" @click="openscreen">全屏</button>
			</div>
			<!-- || changecourse(resourobj.LR_FileSuffix) == 'PDf文档' -->
			<div class="resourcmedios" style="width: 100%;height: 100%;margin: 0;" v-if="changecourse(resourobj.LR_FileSuffix) == '图片'">
				<iframe id="con_lf_top_div" allowfullscreen="true" :src="resourobj.LR_OriginalFileUrl" style="width:100%;height:100%" frameborder="0"></iframe>
			</div>

			<div class="resourcmedios" style="width: 100%;height: 100%;margin: 0;" v-if="changecourse(resourobj.LR_FileSuffix) == 'PDf文档'">
				<iframe style="width:100%;height:100%" :src="resourobj.LR_OriginalFileUrl" frameborder="0"></iframe>
			</div>

			<div class="resourcmedios" v-if="changecourse(resourobj.LR_FileSuffix) == '文档类'">
				<div style="width: 100%;height: 100%;border: 1px solid;overflow:scroll-y;"><vue-office-docx :src="resourobj.LR_OriginalFileUrl" @rendered="rendered" /></div>
			</div>

			<div v-loading="iframeloading" class="resourcmedios" style="height: 80vh;" v-if="resourobj.LR_FileSuffix == 'html' || resourobj.LR_FileSuffix == 'zip'">
				<iframe ref="ifra" id="ifra" style="width: 100%;height: 100%;" :src="resourobj.LR_OriginalFileUrl"></iframe>
			</div>

			<div class="videoplayerheight">
				<div class="resourcmedios" style="height: 100%;" v-if="changecourse(resourobj.LR_FileSuffix) == '视频' && videoSrc">
					<video-player
						class="video-player vjs-custom-skin"
						ref="videoPlayer"
						style="width: 100%;height: 100%;"
						:playsinline="true"
						:options="playerOptions"
						@play="onPlayerPlay($event)"
						@timeupdate="onPlayerTimeupdate($event)"
					></video-player>
				</div>
			</div>
		</div>

		<Myfooters></Myfooters>
	</div>
</template>

<script>
import AppOptions from '../../config/AppOptions.vue';

import Myheaderesa from '@/components/layout/headeresa.vue';

import Myfooters from '@/components/layout/footers.vue';

import putaway from '@/components/putaway.vue';

import Viewer from '../../../node_modules/viewerjs/dist/viewer.min.js';

import '../../../node_modules/viewerjs/dist/viewer.min.css';

import { getResourceDetails, getGetQRCode } from '@/request/api/homesview/yunhomes/yunhom.js';

//引入VueOfficeDocx组件
import VueOfficeDocx from '@vue-office/docx';

import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import { getToken } from '@/utils/auth';
import jsCookie from 'js-cookie';

export default {
	components: {
		Myheaderesa,
		Myfooters,
		putaway,
		VueOfficeDocx,
		videoPlayer
	},
	data() {
		return {
			qrimg: '',
			coursecontent:
				'2022金砖国家技能发展与技术创新大赛由金砖国家工商理事会技能发展工作组（中方）提出并发起，一带一路暨金砖国家技能发展国际联盟为主要组织单位，其目标是为金砖国家建立人才选拔通道，提升人才培养能力，服务先进制造领域，促进金砖国家技能发展。本赛项围绕城市轨道交通站台门系统控制与调试需要掌握的知识点和技能进行设置。全面考察参赛选手对现场作业规程和制度的了解；对设备检查、维护维修及故障处理操作技能的掌握，以及应具备的安全生产意识和职业素养。',
			tabsles: [
				{
					name: '课程目录'
				}
			],
			visible: false,
			resourobj: {},
			size: '',
			// 视频组件
			playerOptions: {
				playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
				autoplay: false, // 如果为true,浏览器准备好时开始回放。
				muted: false, // 默认情况下将会消除任何音频。
				loop: false, // 是否视频一结束就重新开始。
				preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				language: 'zh-CN',
				aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				// fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				sources: [
					{
						type: 'video/mp4', // 类型
						src: '' // url地址
					}
				],
				poster: '', // 封面地址
				notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
				controlBar: {
					timeDivider: true, // 当前时间和持续时间的分隔符
					durationDisplay: true, // 显示持续时间
					remainingTimeDisplay: false, // 是否显示剩余时间功能
					fullscreenToggle: true // 是否显示全屏按钮
				},
				controls: true // 是否显示控制栏
			},
			isscreen: false,
			iframeloading: false,
			videoSrc: ''
		};
	},
	mounted() {
		this.getresour();
		// this.get()
		this.size = this.$route.query.size;
	},
	methods: {
		// 判断iframe是否加载完成
		iframeLoad() {
			var _this = this;
			const iframe = this.$refs.ifra;

			if (iframe.attachEvent) {
				iframe.attachEvent('onload', function() {
					_this.iframeloading = false;
				});
			} else {
				if (iframe) {
					setTimeout(() => {
						_this.iframeloading = false;
					}, 1000);
				}

				// console.log(iframe, '获取');
				iframe.addEventListener('onload', () => {
					_this.iframeloading = false;
				});
				iframe.onload = function() {
					_this.iframeloading = false;
				};
			}
		},
		prowimg() {
			// console.log('课程信息');
			var viewer = new Viewer(document.getElementById('imgsscour'), {
				url: require('@/images/wxewm.png')
			});
			let erimg = {
				Id: this.$route.query.liguid,
				type: 2
			};
			getGetQRCode(erimg).then(res => {
				// console.log(res.data);
				this.qrimg = 'data:image/png;base64,' + res.data;
			});
		},
		changecourse(text) {
			let fixs = 'jpg|png|svg';

			if (fixs.indexOf(text) >= 0) {
				return '图片';
			}

			fixs = 'ogg|mp4|flv';
			if (fixs.indexOf(text) >= 0) {
				return '视频';
			}

			fixs = 'pdf';
			if (fixs.indexOf(text) >= 0) {
				return 'PDf文档';
			}

			fixs = 'doc|docx|txt';
			if (fixs.indexOf(text) >= 0) {
				return '文档类';
			}

			fixs = 'mp3|cd|wave|aiff|mpeg-4|midi|wma|ra|tm|tmx|vqf|amr|ape|flac|aac';
			if (fixs.indexOf(text) >= 0) {
				return '音频';
			}

			if (text == 'html' || text == 'HTML') {
				return '虚拟';
			}
		},
		get() {
			console.log('这里get了几次');
		},
		// 播放
		onPlayerPlay(e) {
			console.log(e, '播放内容');
		},
		onPlayerTimeupdate(e) {
			console.log(e.el_, '这里获取了啥');
			// let du = document.getElementById(e.id_);

			// console.log(du.duration, '获取dom');
			// var hour = parseInt(du.duration / 3600);
			// var minute = parseInt((du.duration % 3600) / 60);
			// var second = parseInt(du.duration % 60);
			// let result = '';
			// if (hour > 0) {
			// 	result = this.formatTimeStr(hour) + ':' + this.formatTimeStr(minute) + ':' + this.formatTimeStr(second);
			// } else {
			// 	result = this.formatTimeStr(minute) + ':' + this.formatTimeStr(second);
			// }
			// console.log(result, '播放内容');
		},
		formatTimeStr(val) {
			if (val > 9) {
				return val;
			} else {
				return '0' + val;
			}
		},
		getresour() {
			getResourceDetails(this.$route.query.liguid).then(res => {
				if (res.data.code > 0) {
					this.resourobj = res.data.data;

					if (this.resourobj.LR_NewFileUrl) {
						this.getVideoUrl(this.resourobj.LR_NewFileUrl);
					}

					if (this.resourobj.LR_FileSuffix == 'html' || this.resourobj.LR_FileSuffix == 'zip') {
						this.iframeloading = true;
						setTimeout(() => {
							this.iframeLoad();
						}, 200);
					}
				}
			});
		},
		openscreen() {
			this.isscreen = !this.isscreen;
		},
		async getVideoUrl(NewFileUrl) {
			try {
				const baseURL = window.myURL.URL;
				let token = getToken();
				if (!token || token.length <= 30) {
					const cookieToken = jsCookie.get('Token');
					if (cookieToken) {
						token = 'Bearer ' + cookieToken.split('&')[0].split('=')[1];
					}
				}
				const response = await fetch(`${baseURL}/Resource/GetVideo?path=${encodeURIComponent(NewFileUrl)}`, {
					headers: { 'Authorization': token }
				});
				if (!response.ok) {
					this.videoSrc = this.resourobj.LR_OriginalFileUrl || '';
					return;
				}
				const blob = await response.blob();
				if (blob.size > 0) {
					const blobUrl = URL.createObjectURL(blob);
					const playerOptions = JSON.parse(JSON.stringify(this.playerOptions));
					playerOptions.sources[0].src = blobUrl;
					this.playerOptions = playerOptions;
					this.videoSrc = blobUrl;
				}
			} catch (e) {
				const fallbackUrl = this.resourobj.LR_OriginalFileUrl;
				if (fallbackUrl) {
					this.videoSrc = fallbackUrl;
				}
			}
		}
	},
	created() {
		AppOptions.appEmpty = true;
		console.log('这里执行了即便');
	},
	beforeRouteLeave(to, from, next) {
		AppOptions.appEmpty = false;
		next();
	}
};
</script>

<style scoped lang="less">
.screenbox {
	width: 100vw !important;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 999;
	.resourcbottomtitle {
		position: relative;
		width: 100%;
		text-align: center;
		color: #fff;
		background-color: #337ab7;
	}
	.resourcmedios {
		width: 100%;
		height: 100% !important;
		background: #000;
	}
	.videoplayerheight {
		height: 1000px;
	}
}

.resourbtns {
	width: 60px;
	height: 20px;
	background: #1bb777;
	border-radius: 4px;
	color: #fff;
	font-size: 12px;
	cursor: pointer;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: 2%;
}

.resourcedetils {
	margin: 60px 0;
}
.resourceright {
	border-radius: 4px;
	img {
		border-radius: 4px;
	}
}

.resourceleft {
	justify-content: space-between;
	width: 100%;
	box-sizing: border-box;
	background-color: #f5f5f5;
	padding: 30px;
	color: #000;
	.resourceleftspan {
		p {
			padding: 0 10px;
			border: 1px solid;
			margin: 0 10px;
			border-radius: 20px;
			color: #fff;
			background-color: #74bd74;
		}
		p:last-child {
			background-color: #5999ca;
		}
	}

	.resourcetimer {
		margin: 20px 0;
	}
}

.resourcbottom {
	border: 1px solid #337ab7;
	border-radius: 5px;
	height: 600px;

	.resourcbottomtitle {
		position: relative;
		width: 100%;
		text-align: center;
		color: #fff;
		background-color: #337ab7;
	}

	.videoplayerheight {
		height: 800px;
	}

	.resourcmedios {
		width: 100%;
		height: 60vh;
		border: 1px solid;
		// margin-bottom: 40px;
		// margin: 30px auto 0 auto;
	}
}

.wrap {
	width: 1200px;
	min-width: 1200px;
	margin: 0 auto;
}

.buttonscour {
	p {
		width: 100px;
		text-align: center;
		height: 30px;
		line-height: 30px;
		color: #fff !important;
		background-color: #1bb777;
		margin: 0 10px !important;
		border-radius: 20px;
		cursor: pointer;
	}
}

.detacontent {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box; //作为弹性伸缩盒子模型显示。
	-webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
	-webkit-line-clamp: 3; //显示的行
	font-size: 16px;
	margin: 20px 0;
}

.detailscontengt {
	width: 1200px;
	min-width: 1200px;
	margin: 40px auto 20px auto;
	.detailscontitle {
		font-size: 18px;
		color: #000;
	}
	img {
		width: 40px;
		height: 40px;
	}
	p {
		font-size: 16px;
		color: #b0b0b0;
		margin: 10px 0;
		span {
			color: #000;
		}
	}
	.fontstimers {
		font-size: 16px;
		color: #b0b0b0;
		margin: 10px 0;
		span {
			color: #000;
		}
	}
}

.contents {
	width: 1200px;
	min-width: 1200px;
	margin: 0 auto;
}

.headerscourdetail {
	position: relative;
	.headerfonts {
		position: absolute;
		top: 40px;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;

		p:first-child {
			font-size: 30px;
			color: #000;
			font-weight: 600;
		}
		p:last-child {
			font-size: 18px;
			margin-top: 10px;
		}
	}
}

.flex {
	display: flex;
}
.fley {
	display: flex;
	flex-direction: column;
}

.contentscours {
	height: 40px;
	border-bottom: 1px solid #ccc;
	p {
		width: 80px;
		height: 40px;
		font-size: 20px;
		line-height: 40px;
		overflow: inherit;
		margin: 0 20px;
	}

	.scouractive {
		border-bottom: 4px solid #0054ff;
		color: #0054ff;
	}
}

.contents {
	margin-bottom: 60px;
	.treestitleone {
		margin-top: 20px;
		.tresstiele {
			font-size: 20px;
			color: #000;
			font-weight: 700;
		}
	}
	.treestitletwotitle {
		margin-left: 40px;
		margin-top: 20px;
		font-size: 16px;
		color: #000;
	}

	.treestitletwotts {
		margin-top: 10px;
		margin-left: 60px;
		cursor: pointer;
	}
}
</style>
